"use client";

import { useEffect, useRef } from "react";
import { clsx } from "@frend-digital/ui";
import { CategoryLink } from "./CategoryLink";
import { sbLink } from "@/lib/storyblok/link";
import { addLeadingSlash } from "@frend-digital/utils";
import styles from "./ProductListingPage.module.css";

interface CategoriesClientProps {
	storyLinks: Array<{
		id: number;
		uuid: string;
		slug: string;
		name: string;
	}>;
	activeStoryId: number;
	activeStorySlug: string;
}

export const CategoriesClient = ({
	storyLinks,
	activeStoryId,
	activeStorySlug,
}: CategoriesClientProps) => {
	const categoriesRef = useRef<HTMLElement>(null);
	const activeRef = useRef<HTMLAnchorElement>(null);

	useEffect(() => {
		if (activeRef.current && categoriesRef.current) {
			const container = categoriesRef.current;
			const activeElement = activeRef.current;

			const containerWidth = container.offsetWidth;
			const elementLeft = activeElement.offsetLeft;
			const elementWidth = activeElement.offsetWidth;

			const scrollPosition = elementLeft - containerWidth / 2 + elementWidth / 2;

			container.scrollTo({
				left: scrollPosition,
				behavior: "smooth",
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<aside ref={categoriesRef} className={styles.categories}>
			{storyLinks.map((link) => {
				if (
					storyLinks.length === 1 &&
					addLeadingSlash(link.slug) === addLeadingSlash(activeStorySlug)
				) {
					return null;
				}

				const isActive = link.id === activeStoryId;

				return (
					<CategoryLink
						ref={isActive ? activeRef : undefined}
						className={clsx(styles.category, isActive && styles.active)}
						href={sbLink(addLeadingSlash(link.slug))?.href || ""}
						key={link.uuid}
					>
						{link.name}
					</CategoryLink>
				);
			})}
		</aside>
	);
};
